// extracted by mini-css-extract-plugin
module.exports = {"read":"TextRead_read__3I6lo"};